import { Chip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
  codigoAtivo: string;
  size?: "medium" | "small";
  color?: "primary" | "secondary";
  startIcon?: React.ReactElement;
};

export default function Ticker({
  codigoAtivo,
  size = "small",
  color = "secondary",
  startIcon,
}: Props) {
  return (
    <Chip
      component={Link}
      clickable
      to={`/consulta#${codigoAtivo}`}
      avatar={startIcon}
      size={size}
      color={color}
      // Ticker é código: mono tabular para não "dançar" entre linhas de tabela.
      sx={(theme) => ({
        fontSize: 12,
        fontFamily: theme.typography.dataMono.fontFamily,
        fontVariantNumeric: "tabular-nums",
        letterSpacing: "0.04em",
        "& .MuiChip-label": {
          fontWeight: 600,
        },
      })}
      label={codigoAtivo}
    />
  );
}
